import React from 'react';
import PaymentResult from './PaymentResult';

export default function SuccessPayment() {
  return <PaymentResult status="success" />;
}